export default __webpack_public_path__ + "static/01-2f7dc81f97a2171df060e76354259228.jpg";